import { Fetch } from 'lib';
import type { Watermark } from 'types';

type RequestResponses = {};

type RequestParameters = {};

type RequestBody = Partial<Watermark>;

const updateWatermark = async (body: RequestBody) =>
  await Fetch<RequestResponses, RequestParameters, RequestBody>({
    url: 'adminConfig/updateWatermark',
    method: 'PUT',
    body,
  });

export { updateWatermark };
